import { useEffect } from 'react';
import AuthService from '../services/auth.service';
import SsoLoginPage from './SsoLoginPage';

export default function ExtLogin() {
  const authService = AuthService.getInstance();

  // Custom domain with SSO — show the email form
  if (authService.isCustomDomain && authService.ssoEnabled) {
    return <SsoLoginPage />;
  }

  // Otherwise, redirect externally
  useEffect(() => {
    if (authService.isCustomDomain && authService.returnToken) {
      const returnTo = encodeURIComponent(window.location.origin);
      const token = encodeURIComponent(authService.returnToken);
      window.location.href = `${authService.authAppUrl}/login?returnTo=${returnTo}&returnToken=${token}`;
    } else if (authService.isCustomDomain) {
      window.location.href = `${authService.authAppUrl}/login`;
    } else {
      window.location.href = `${authService.authAppUrl}/login`;
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Redirecting to login...</div>
    </div>
  );
}
